import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import { Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import CustomEditor from "../../components/Editor";
import { TextField as FormikTextField } from "formik-material-ui";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { updateApplicationKind, updateApplicationmanag } from "../../../services/applicationKindsService";
import useLocale from "../../../hooks/useLocale";
import { useMutation } from "react-query";

const useStyles = makeStyles({
  dialog: {
    height: 600,
  },
});

const UpdateDialog = ({ open, close, refetch, selectedItem }) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  const [editorState, setEditorState] = useState("");
  const classes = useStyles();

  useEffect(() => {
    setEditorState(() => {
      const template = `${selectedItem.details}`;
      const contentBlock = htmlToDraft(template);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        return newEditorState;
      }
    });
  }, [selectedItem]);

  // Mutation for creating data
  const { mutate } = useMutation(updateApplicationmanag, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      // console.log("error updateApplicationKind : ");
      // console.log(error.response.status);
      if (error.response.status == 401) {
        // console.log("----");
        setError("Δεν έχετε δικαιώματα για αυτή την λειτουργία.");
      } else {

        switch (error) {
          default: {
            setError(t("A network error occured. Please try again later") + error.response.status);
          }
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    cd: Yup.string().required(t("Field is required")).max(512, t("Too long")),
    dscr: Yup.string().required(t("Field is required")).max(512, t("Too long")),
    detail: Yup.string(),
  });

  const handleUpdateItem = (values) => {
    mutate({
      ...values,
      id: selectedItem.id,
    });
  };

  const onEditorStateChange = (newEditorState, setFieldValue) => {
    setEditorState(newEditorState);
    setFieldValue(
      "details",
      draftToHtml(convertToRaw(newEditorState?.getCurrentContent()))
    );
  };

  const getErrorMessage = (error) => {
    // console.log(error)
    return error;
  }

  return (
    <CustomDialog
      open={open}
      maxWidth="lg"
      onClose={() => {
        close();
        setError("");
        setEditorState("");
      }}
    >
      <DialogTitle id="form-dialog-title">
        {t("Edit Application Kind")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Fill in the form below and then click on Save to update the Application Kind"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}

        message={getErrorMessage(error)}
      />
      <Formik
        initialValues={{
          dscr: selectedItem.dscr,
          cd: selectedItem.cd,
          details: selectedItem.details,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleUpdateItem(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting, setFieldValue }) => (
          <Form>
            <DialogContent className={classes.dialog}>
              <Field
                component={FormikTextField}
                fullWidth
                name="cd"
                label={t("Code")}
              />
              <Field
                margin="normal"
                component={FormikTextField}
                fullWidth
                name="dscr"
                label={t("Description")}
              />
              <CustomEditor
                editorStyle={{
                  border: "1px solid",
                  minHeight: 250,
                  borderRadius: 5,
                  padding: 5,
                }}
                name="details"
                editorState={editorState}
                onEditorStateChange={(newValue) =>
                  onEditorStateChange(newValue, setFieldValue)
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={submitForm} color="primary">
                {t("Save")}
              </Button>
              <Button
                onClick={() => {
                  close();
                  setError("");
                  setEditorState("");
                }}
                color="primary"
              >
                {t("Cancel")}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default UpdateDialog;
